import { render, staticRenderFns } from "./CompliantBlock.vue?vue&type=template&id=1683e406&scoped=true&lang=pug"
import script from "./CompliantBlock.vue?vue&type=script&lang=ts"
export * from "./CompliantBlock.vue?vue&type=script&lang=ts"
import style0 from "./CompliantBlock.vue?vue&type=style&index=0&id=1683e406&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1683e406",
  null
  
)

export default component.exports